import React from 'react'

export default () => (
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M3.21852 8L10 14.4657L8.39074 16L0 8L8.39074 0L10 1.53432L3.21852 8Z" fill="currentColor"/>
  </svg>

)
